export function fetchedToken(state: string = localStorage.getItem('token') || '', action: any) {
    switch (action.type) {
        case 'AUTH_TOKEN':
            return action.fetchedToken

        default:
            return state
    }
}

export function user(state: object = {isFetching: false, entities: {}, error: ''}, action: any) {
    switch (action.type) {
        case 'FETCHING_USER':
            return Object.assign({}, state, {isFetching: action.data})

        case 'FETCH_USER_SUCCESS':
            return Object.assign({}, state, {entities: action.data})

        case 'FETCH_USER_ERROR':
            return Object.assign({}, state, {error: action.data})

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/auth.tsx